export default "__VITE_ASSET__DSc6jEsv__"